// extracted by mini-css-extract-plugin
export default {"accordionItem":"AccordionItem_accordionItem__YldKz","collapsed":"AccordionItem_collapsed__xrJoM"};